module.exports = __webpack_public_path__ + "static/media/ntuc-link-mobile-image.dc2dacf9.jpg";